<template>
  <v-card class="purchase-section" flat>
    <div class="mb-7">{{ $t("profile_coupon") || "MY COUPONS" }}</div>
    <template v-if="couponList.length == 0">
      <div class="mt-3">{{ $t("no_data") }}</div>
    </template>
    <template v-else>
      <v-row no-gutters class="h-100 coupon-list">
        <template v-for="(item, index) in couponList" :key="index">
          <v-col cols="5" class="h-100" @click="openCouponDetail(item)">
            <div class="h-100">
              <c-img-lazy
                v-if="item.image_url"
                v-bind="mainProps"
                :src="item.image_url"
                class="lazy-image"
                alt="Image 1"
              ></c-img-lazy>
              <c-img-lazy
                v-else
                v-bind="mainProps"
                :src="require('@/assets/images/default-image.png')"
                class="lazy-image"
                alt="Image 1"
              ></c-img-lazy>
            </div>
          </v-col>
          <v-col cols="7" @click="openCouponDetail(item)">
            <div class="d-flex flex-column h-100 p-2" style="row-gap: 5px">
              <div class="line-clamp-1 f-bold">{{ item.name }}</div>
              <div class="line-clamp-2 f-bold">{{ item.detail }}</div>
              <div>
                {{ $t("expired_date") }}:
                {{ $moment(item.expired_date).format("DD/MM/YYYY") }}
              </div>

              <div>
                {{ $t("status") }}:

                <span v-if="item.already_use == 1">
                  {{ $t("already_used") }}
                </span>
                <span
                  v-else-if="
                    $moment().isAfter($moment(item.expired_date)) ||
                    item.mark_used_expire == 1
                  "
                >
                  {{ $t("expired") }}
                </span>
                <span v-else>Active</span>
              </div>
              <div class="mt-auto">
                {{ $t("see_detail") }}
                <font-awesome-icon icon="chevron-right" size="sm" />
              </div>
            </div>
          </v-col>
        </template>
      </v-row>
    </template>
  </v-card>

  <v-dialog
    v-model="showCouponDetail"
    fullscreen
    hide-overlay
    transition="slide-up-down"
    class="purchase-history-dialog"
  >
    <v-card class="p-3">
      <div class="d-flex">
        <font-awesome-icon
          icon="times"
          class="ml-auto f-title"
          @click="showCouponDetail = false"
        ></font-awesome-icon>
      </div>
      <div class="f-bold mb-6">
        {{ $t("coupon_detail_title") || "Coupon Details" }}
      </div>
      <div>
        <c-img-lazy
          v-if="couponDetail.image_url"
          v-bind="mainProps"
          :src="couponDetail.image_url"
          class="lazy-image"
          alt="Image 1"
        ></c-img-lazy>
        <c-img-lazy
          v-else
          v-bind="mainProps"
          :src="require('@/assets/images/default-image.png')"
          class="lazy-image"
          alt="Image 1"
        ></c-img-lazy>
      </div>
      <div class="privilege-box-detail f-body mt-5">
        <div class="f-bold">{{ couponDetail.name }}</div>
        <div class="f-bold">{{ couponDetail.short_description }}</div>
        <div v-if="!isExpired">
          {{ $t("expired_date") }}:
          {{ $moment(couponDetail.end_datetime).format("DD/MM/YYYY") }}
        </div>
        <div>
          {{ $t("status") }}:

          <span v-if="couponDetail.already_use == 1">
            {{ $t("already_used") }}
          </span>
          <span v-else-if="isExpired">
            {{ $t("expired") }}
          </span>
          <span v-else>Active</span>
        </div>
        <div
          v-if="couponDetail.description"
          @click="handleClick"
          v-html="couponDetail.description"
          class="mt-8 mb-10"
        ></div>
        <div v-else>-</div>
      </div>
      <c-btn
        class="w-100 mt-auto"
        :variant="
          couponDetail.status === 0 || isExpired
            ? 'outline-disabled'
            : 'outline-primary'
        "
        @click="confirmMarkUse"
        :disabled="
          couponDetail.status === 0 ||
          isExpired ||
          couponDetail.already_use == 1
        "
      >
        {{ $t("use_coupon") }}
      </c-btn>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="confirmMarkUseModal"
    fullscreen
    hide-overlay
    transition="slide-up-down"
    class="purchase-history-dialog"
  >
    <v-card class="p-3">
      <div class="d-flex">
        <font-awesome-icon
          @click="confirmMarkUseModal = false"
          icon="times"
          class="ml-auto f-title"
        ></font-awesome-icon>
      </div>
      <div class="f-bold mb-6">
        {{ $t("coupon_note_title") || "REDEEM VOUCHER" }}
      </div>
      <div v-html="$t('coupon_note')"></div>
      <div class="mt-auto">
        <c-btn class="w-100" variant="primary" @click="beforeOnConfirm">
          {{ $t("use_coupon") }}
        </c-btn>
        <c-btn class="w-100 mt-4" variant="outline-primary">
          {{ $t("cancel") }}
        </c-btn>
      </div>
    </v-card>
  </v-dialog>
  <ModalLoading ref="modalLoading" />
</template>

<script>
var z;
import ModalLoading from "@/components/other/ModalLoading.vue";
import QRDialogContent from "@/components/dialog-content/QRDialogContent.vue";
import BranchSelectionDialogContent from "@/components/dialog-content/BranchSelectionDialogContent.vue";
import { useDialog } from "@/services/dialogService";
export default {
  setup() {
    const dialog = useDialog();
    return { dialog };
  },
  components: {
    ModalLoading
  },
  created() {
    this.getCouponList();
  },

  data() {
    return {
      couponList: [],
      showCouponDetail: false,
      confirmMarkUseModal: false,
      couponDetail: {},
      couponID: 0,
      filter: {
        month_ago: 0,
        all_flag: true,
        page: 1,
        pageSize: 5
      },
      totalPages: 1,
      countTime: "--:--",
      confirmRedeem: {
        header: `${this.$t("confirm_used")} ?`,
        text: "",
        subText: "",
        button: {
          true: {
            class: ["btn-danger"],
            msg: this.$t("confirm")
          },
          false: {
            class: ["btn-secondary"],
            msg: this.$t("cancel")
          }
        }
      },
      modalMessage: "แก้ข้อผิดพลาดกรุณาลองใหม่ภายหลัง",
      msg: this.$t("coupon_is_already_used") || "คูปองถูกใช้งานเรียบร้อย"
    };
  },
  computed: {
    isExpired() {
      if (this.couponDetail.is_expired == 1) return true;
      return false;
    }
  },
  methods: {
    async showQRDialog() {
      await this.dialog.showCustom(QRDialogContent, {
        name: this.couponDetail.name,
        code: this.couponDetail.prefix,
        countTime: this.countTime,
        allow: this.couponDetail.allow_customer_redeem,
        markUse: this.couponDetail.is_auto_mark_use == 1
      });
      this.closePage();
    },
    async onConfirm(branchId) {
      try {
        this.$refs.modalLoading.show();
        const res = await this.$axios.post(
          `/api/v1/Reward/redeem_coupon/${branchId || this.branch_id}`,
          this.couponDetail
        );
        this.$refs.modalLoading.hide();
        if (!res.result) {
          this.modalMessage = res.message;
          await this.dialog.showError({ text: this.modalMessage });
        } else {
          await this.$store.dispatch("refreshUserProfile");
          await this.showQRDialog();
        }
      } catch (error) {
        console.log(error);
        await this.dialog.showError({ text: this.modalMessage });
      }
    },
    filterCouponList(coupons) {
      // จัดกลุ่มตาม promotion_id

      const grouped = coupons.reduce((acc, item) => {
        const id = item.promotion_id;
        if (!acc[id]) acc[id] = [];
        acc[id].push(item);
        return acc;
      }, {});

      const result = [];

      for (const group of Object.values(grouped)) {
        if (group.length === 1) {
          // ไม่มีซ้ำ → แสดงได้เลย
          result.push(group[0]);
        } else {
          const hasUserCoupon = group.filter(c => c.user_coupon_id > 0);
          const hasMarkUsedExpire1 = hasUserCoupon.some(
            c => c.mark_used_expire === 1
          );

          if (hasMarkUsedExpire1) {
            let a = group;
            if (
              group.some(
                el => el.user_coupon_id != 0 && el.mark_used_expire == 0
              )
            )
              a = group.filter(el => el.user_coupon_id != 0);
            // มี user_coupon_id > 0 และ mark_used_expire == 1 → แสดงทั้งหมดรวม user_coupon_id == 0
            result.push(...a);
          } else if (hasUserCoupon.length > 0) {
            // มี user_coupon_id > 0 และ mark_used_expire == 0 → แสดงเฉพาะที่มี user_coupon_id
            result.push(...hasUserCoupon);
          } else {
            // ไม่มี user_coupon_id เลย → แสดงตัวแรกพอ
            result.push(group[0]);
          }
        }
      }

      return result;
    },
    async getCouponList() {
      this.emitter.emit("showLoading");
      const result = await this.$axios(
        "/api/v1/Privilege/privilege_all_status"
      );
      this.emitter.emit("hideLoading");
      let coupon = result.detail.map((el, index) => {
        return { ...el, sort_order: index };
      });
      let temp = this.filterCouponList(coupon);
      function duplicateUsedCoupons(arr) {
        const result = [];

        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];

          // ถ้าเงื่อนไขตรง → แทรก duplicate ก่อน
          if (item.availability === 1 && item.already_use === 1) {
            result.push({ ...item }); // duplicate ก่อนหน้า
          }

          result.push(item); // ตัวจริง
        }

        return result;
      }
      temp = temp.sort((a, b) => a.sort_order - b.sort_order);
      this.couponList = duplicateUsedCoupons(temp);
      this.totalPages = result.detail.allPage;
    },
    openDetail(id) {
      this.showCouponDetail = true;
      this.couponID = id;
    },
    hideDetail() {
      this.showCouponDetail = false;
      this.couponID = 0;
    },
    changePage(type) {
      if (type) {
        if (this.filter.page == this.totalPages) return;
        this.filter.page = this.filter.page + 1;
      } else {
        if (this.filter.page == 1) return;
        this.filter.page = this.filter.page - 1;
      }
      this.getCouponList();
    },
    async openCouponDetail(value) {
      this.showCouponDetail = true;
      this.couponDetail = await this.getCouponDetail(value);
    },
    async getCouponDetail({ promotion_id, user_coupon_id, already_use }) {
      const res = await this.$axios.get(
        `/api/v1/Privilege/coupon_detail/${promotion_id}?user_coupon_id=${user_coupon_id}`
      );
      return { ...res.detail.detail.detail, already_use };
    },
    beforeOnConfirm() {
      if (this.couponDetail.is_auto_mark_use == 1) this.markUseCoupon();
      else if (this.couponDetail.allow_customer_redeem) this.useCoupon();
      else this.showQRDialog();
      this.confirmMarkUseModal = false;
    },
    async markUseCoupon() {
      this.$refs.modalLoading.show();
      const res = await this.$axios.post(
        "/api/v1/reward/redeem_coupon/auto_mark_use",
        this.couponDetail
      );
      this.couponDetail.customer_redeem_date = res.detail.customer_redeem_date;
      if (res.result == 0) {
        this.msg = res.message;
        this.preventHideEvent = true;
        await this.dialog.showAlert({ text: this.msg });
        this.$router.replace({ path: "" });
        return;
      }
      // this.$refs.modalAlert.show();
      this.countTimer(res.detail.customer_redeem_date);
      this.$router.replace({
        query: {
          user_coupon_id: res.detail.user_coupon_id
        }
      });
      this.preventHideEvent = false;
      this.$refs.modalLoading.hide();
      await this.showQRDialog();
    },
    confirmMarkUse() {
      if (this.couponDetail.is_auto_mark_use == 0) {
        this.confirmMarkUseModal = true;
      } else if (
        this.couponDetail.is_auto_mark_use == 0 ||
        (this.couponDetail.is_auto_mark_use == 1 &&
          this.couponDetail.customer_redeem_date)
      ) {
        this.countTimer(this.couponDetail.customer_redeem_date);
        return this.showQRDialog();
      }
      this.confirmMarkUseModal = true;
    },
    countTimer(val = null) {
      this.couponExpired = false;
      if (!this.couponDetail.customer_redeem_date && !val) return;

      function padZero(value) {
        value = String(value);
        return value.length == 1 ? "0" + value : value;
      }
      var diff = this.$moment(val || this.couponDetail.customer_redeem_date)
        .add(this.couponDetail.min_count_down, "minutes")
        .valueOf();

      this.showCountTime = true;

      var countDownDate = diff;

      z = setInterval(() => {
        var now = this.$moment().valueOf();
        var distance = countDownDate - now;

        var minutes = padZero(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        );

        var seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));

        if (distance < 0) {
          this.couponExpired = true;

          // this.$refs.ModalQR.close();
          return clearInterval(z);
        }

        this.$nextTick(() => {
          this.countTime = minutes + " : " + seconds;
        });
      }, 1000);
    },
    closePage() {
      this.showCouponDetail = false;
      this.getCouponList();
    },
    async useCoupon() {
      const data = await this.$axios.get(
        `/api/v1/Reward/redeem_coupon/${this.couponDetail.branch_group_id}`
      );
      var branchList = [];
      for (const { branch } of data.detail) {
        branchList.push(...branch.filter(el => el.is_check));
      }
      if (branchList.length == 1) return this.onConfirm(branchList[0].id);

      const result = await this.dialog.showCustom(BranchSelectionDialogContent, {
        variant: "privilege",
        branch: branchList,
        detail: this.couponDetail
      });
      if (result?.action === "confirm") {
        await this.onConfirm(result.branchId, result.body);
      }
    }
  }
};
</script>

<style lang="scss">
.purchase-message {
  padding: 10px;
  font-size: var(--font-body);
  // color: #808080;
}
.table-purchase-history {
  // height: 60vh;
  th {
    font-weight: 600 !important;
    white-space: nowrap;
  }
  td {
    // color: gray;
    // opacity: 0.4;
  }
}
.v-table > .v-table__wrapper > table > tbody > tr > td,
.v-table > .v-table__wrapper > table > tbody > tr > th,
.v-table > .v-table__wrapper > table > thead > tr > td,
.v-table > .v-table__wrapper > table > thead > tr > th,
.v-table > .v-table__wrapper > table > tfoot > tr > td,
.v-table > .v-table__wrapper > table > tfoot > tr > th {
  padding: 0;
  text-align: center;
  // font-weight: 600;
}
tbody,
td,
tfoot,
th,
thead,
tr {
  border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

// .v-table > .v-table__wrapper > table > thead > tr > th {
// } /* เปิด: เลื่อนขึ้น */

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
}
.page-disabled {
  opacity: 0.5;
}
.v-dialog.v-dialog--fullscreen.purchase-history-dialog > .v-overlay__content {
  background-color: var(--theme-background-color);
}
.v-table > .v-table__wrapper > table > tbody > tr > td,
.v-table > .v-table__wrapper > table > thead > tr > th {
  padding: 0 5px !important;
}
.compact-page {
  top: calc(99vh - (var(--padding-footer) + var(--header-height)));
  width: 100%;
  position: absolute;
  left: 0;
  padding: 16px 24px;
  border-top: 1px solid rgba(8, 8, 8, 0.15);
}
.coupon-list {
  row-gap: 20px;
}
</style>
